import { connect } from 'react-redux';
import View from './view'
import {onDriverLoaded, executeEvent} from './action'
import {EventModel} from './model'

const stateToProps = (state) => state.vrtour;
const actionToProps = new EventModel({onDriverLoaded, executeEvent});

export default connect(stateToProps, actionToProps)(View);